export default "__VITE_ASSET__c53eafd3__"